/**
 * mosaicContext.ts
 */
import Event from '@shared/classes/event';
import Setting from '@shared/classes/setting';
import { createContext } from 'react';
import { GridDisplayMode } from '@shared/types/enums/grid';
import { MosaicConfig } from '@shared/types/interfaces/mosaic';

/**
 * Props for the MosaicContext.
 */
interface MosaicContextProps {
  asset?: Event | Setting;
  config: MosaicConfig;
  data: (Event | Setting)[];
  index: number;
  onMouseEnter: () => void;
  hoverAsset: (asset: Event | Setting) => void;
  selectAsset: (index: number) => void;
}

const MosaicContext = createContext<MosaicContextProps>({
  asset: undefined,
  data: [],
  config: {
    columns: 0,
    rows: 0,
    description: false,
    displayMode: GridDisplayMode.PHOTO,
    minimumIndex: 0,
  },
  index: 0,
  onMouseEnter: () => null,
  hoverAsset: () => null,
  selectAsset: () => null,
});

export default MosaicContext;
export type { MosaicContextProps };
